<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  currentSection: number,
  maxSection: number,
  number: number,
  title?: string,
  icon?: string,
}>();

interface EmitInterface {
  (event: 'goToSection', value: number, isLast: boolean): void
}

const emits = defineEmits<EmitInterface>();

const reached = computed(() => props.maxSection >= props.number);
const current = computed(() => props.currentSection === props.number);
const maxCurrent = computed(() => props.maxSection === props.number);
const canChangeStep = computed(() => reached.value && !current.value);

const emitSectionChange = ():void => {
  const newSection = props.number - 1;
  if (props.maxSection > newSection) {
    emits('goToSection', newSection, props.currentSection === props.maxSection);
  }
};

</script>

<template>
  <span class="rounded-full flex items-center justify-center h-6 w-6 z-10 transition-colors delay-200 duration-500" :class="{ 'bg-blue-400': reached, 'bg-gray-100 border border-gray-400': !reached, 'cursor-pointer': canChangeStep }" @click="emitSectionChange">
    <span v-if="title" class="bottom-full absolute hidden md:inline-block pb-2" :class="{ 'text-blue-400': reached, 'text-gray-400': !reached }">
      <span class="whitespace-nowrap" :class="{ 'font-bold': current }">{{ title }}</span>
    </span>
    <span v-if="!reached || maxCurrent">
      <hfc-icon v-if="icon" :icon="['fa', icon]" class="z-10" :class="{ 'text-white': reached, 'text-gray-400': !reached }" />
      <hfc-icon v-else-if="number <= 9" :icon="['fa', `${number}`]" class="z-10" :class="{ 'text-white': reached, 'text-gray-400': !reached }" />
      <span v-else class="font-medium" :class="{ 'text-white': reached, 'text-gray-400': !reached }">{{number}}</span>
    </span>
    <hfc-icon v-else :icon="['fa', 'check']" class="text-white z-50" />
  </span>
</template>
